module.exports = __webpack_public_path__ + "img/buildingImg.b36ad77e.jpg";